import React from 'react';
import styles from './Accordion.module.scss';
import Arrow from '../../../Icons/Arrow';

export default function Accordion({ item, onOpen }) {
  return (
    <div className={styles.accordion}>
      <div className={styles.accordion_header} onClick={() => onOpen(item.id)}>
        <h3 className={styles.accordion_header_title}>{item.title}</h3>
        <Arrow isRotated={item.isOpen} />
      </div>
      <ul
        className={styles.accordion_list}
        style={{
          height: item.isOpen ? 'auto' : 0,
          opacity: item.isOpen ? 1 : 0,
          transition: 'height 0.3s, opacity 0.3s',
          overflow: 'hidden',
        }}
      >
        {item.items.map((el) => (
          <li key={el.id} className={styles.accordion_list_item}>
            <a href={el.path}>{el.title}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
